/**
 * プルダウンパーツ
 * ※本パーツは直接利用せず、継承して利用する
 */
export default class CustomPulldownBase extends HTMLElement {

  constructor() {
    super();

    // 各種要素の取得
    this.list = this.querySelectorAll("input[type=radio]");
    this.detail = this.querySelector('details');
    this.summary = this.detail.querySelector('summary');
    this.content = this.detail.querySelector('.unico-pulldown-content');

    // 初期選択値のラベル反映
    this.applySelectedValue();

    // 開閉処理
    this.summary.addEventListener("click", (e) => this.toggleOpen(e));

    // プルダウン選択時のイベント登録
    this.list.forEach((item)=> {
      item.addEventListener("change", (e) => {
        this.applySelectedValue();
        this.toggleOpen(e);
        this.selectItem(e);
      });
    });
  }

  /**
   * プルダウンの開閉
   * @param e
   */
  toggleOpen(e) {
    e.preventDefault();

    if (this.detail.open) {
      const closeDetails = this.content.animate(
        {
          opacity: [1, 0],
          height: [this.content.offsetHeight + 'px', 0],
        },
        {
          duration: 150,
          easing: 'ease-in',
        }
      );
      closeDetails.onfinish = () => {
        this.detail.removeAttribute('open');
      }
    } else {
      this.detail.setAttribute('open', 'true');
      const openDetails = this.content.animate(
        {
          opacity: [0, 1],
          height: [0, this.content.offsetHeight + 'px'],
        },
        {
          duration: 150,
          easing: 'ease-in',
        }
      );
    }
  }

  /**
   * 選択したテキストをラベルに反映します
   */
  applySelectedValue() {
    this.list.forEach((item)=> {
      if (item.checked) {
        this.summary.innerHTML = item.nextElementSibling.innerHTML;
      }
    });
  }


  /**
   * プルダウン選択時の個別実行処理
   * ※任意の処理でoverrideして実行する
   */
  selectItem(e) {
  }
}
